<template>
  <div class="layout">
    <!-- header -->
    <header>
      <HeaderBar></HeaderBar>
    </header>
    <!-- container -->
    <main>
      <router-view/>
    </main>
    <!-- footer -->
    <footer class="footer">
      <FooterBar></FooterBar>
    </footer>
  </div>
</template>

<script>
import HeaderBar from './components/headerBar.vue'
import FooterBar from './components/footerBar.vue'
export default {
  name: 'layout',
  components: {
    HeaderBar, FooterBar
  }
}
</script>

<style lang="scss" scoped>
  
</style>